/* eslint-disable react/no-array-index-key */
import React from "react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { BiRightArrowAlt } from "react-icons/bi";
import { Link } from "react-router-dom";

export default function BreadCrumb({ links = [] }) {
  return (
    <Breadcrumb separator={<BiRightArrowAlt color="gray.500" />}>
      {links.map((link, index) => {
        return (
          <BreadcrumbItem key={index}>
            <BreadcrumbLink
              as={Link}
              to={link.link ? link.link : ""}
              isCurrentPage={Boolean(link.isCurrentPage)}
            >
              {link.text}
            </BreadcrumbLink>
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
}
